import Model from "./Model";

export default class Aluno extends Model {
  constructor(aluno) {
    super();
    Object.assign(this, aluno);
  }
}
